import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import NewsPage from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import UpdatesPage from "@/pages/updates/page";
import UpdateDetail from "@/pages/updates/detail/page";
import CharactersPage from "@/pages/characters/page";
import CharacterDetail from "@/pages/characters/detail/page";
import CommunityPage from "@/pages/community/page";
import TopicDetail from "@/pages/community/detail/page";
import AboutPage from "@/pages/about/page";
import HelpPage from "@/pages/help/page";
import SearchPage from "@/pages/search/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "news", element: <NewsPage /> },
      { path: "news/:id", element: <NewsDetail /> },
      { path: "updates", element: <UpdatesPage /> },
      { path: "updates/:id", element: <UpdateDetail /> },
      { path: "characters", element: <CharactersPage /> },
      { path: "characters/:id", element: <CharacterDetail /> },
      { path: "community", element: <CommunityPage /> },
      { path: "community/:topicId", element: <TopicDetail /> },
      { path: "about", element: <AboutPage /> },
      { path: "help", element: <HelpPage /> },
      { path: "search", element: <SearchPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;